export const cityAttractionsConstants = {
	

	SEARCH_REQUEST: "SEARCH_REQUEST",
	SEARCH_SUCCESS: "SEARCH_SUCCESS",
	SEARCH_FAILURE: "SEARCH_FAILURE",

	
	ARICLE_REQUEST: "ARICLE_REQUEST",
	ARICLE_SUCCESS: "ARICLE_SUCCESS",
	ARICLE_FAILURE: "ARICLE_FAILURE",
	
};
